import React from "react";

/**
 * Infinite editorial marquee. Duplicates its items so the loop is seamless.
 */
const Marquee = ({
  items = [],
  reverse = false,
  speed = "normal",
  separator = "✦",
  className = "",
  itemClassName = "",
}) => {
  const animation = reverse
    ? "animate-marquee-reverse"
    : speed === "slow"
    ? "animate-marquee-slow"
    : "animate-marquee";

  const loop = [...items, ...items];

  return (
    <div className={`group relative flex overflow-hidden mask-fade-x ${className}`}>
      <div
        className={`flex w-max shrink-0 items-center ${animation} group-hover:[animation-play-state:paused]`}
      >
        {loop.map((item, i) => (
          <span
            key={i}
            className={`flex shrink-0 items-center whitespace-nowrap ${itemClassName}`}
          >
            {item}
            <span className="mx-6 text-electric md:mx-10" aria-hidden="true">
              {separator}
            </span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
